export const FECHA_TEST_DRIVE = {
  value: "01-08",
  label: "Sábado 1 de Agosto",
};
